/**
 * Phase 45 Plan 45-05 — Filter row (5 chips + Group-by toggle).
 *
 * Source: UI-SPEC §Surface 1 Filter row spec. The 5 chips render read-only
 * in v7.0; full filter state machine deferred to v7.1 per CONTEXT D-09 +
 * UI-SPEC §Out-of-Scope. Period chip "Custom" surfaces disabled with a
 * "Coming v7.1" tooltip per RESEARCH Open Q1.
 */
import { FilterChip } from './FilterChip';
import { GroupByToggle, type GroupBy } from './GroupByToggle';
import type { PortfolioRow, PortfolioPeriodInfo } from '../../services/api/portfolio';

export interface ManagerOverviewFilterRowProps {
  projects: PortfolioRow[];
  period: PortfolioPeriodInfo;
  groupBy: GroupBy;
  onGroupByChange: (v: GroupBy) => void;
}

export function ManagerOverviewFilterRow({
  projects,
  period,
  groupBy,
  onGroupByChange,
}: ManagerOverviewFilterRowProps) {
  const customerCount = new Set(
    projects.map((p) => p.customerId).filter((id): id is number => id !== null),
  ).size;
  const ownerCount = new Set(
    projects.map((p) => p.projectManager?.id).filter((id): id is number => id !== undefined),
  ).size;
  const activeCount = projects.length; // backend already filters to active

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {/* FILTER WIRING DEFERRED TO v7.1 — chips render disabled state only;
          tooltip surfaces the deferment on hover (Petra UAT 2026-05-22).
          See CONTEXT D-09 + UI-SPEC §Out-of-Scope. */}
      <FilterChip
        label="Customer"
        value="All"
        count={customerCount}
        disabled
        tooltip="Filtering coming v7.1"
      />
      <FilterChip
        label="Owner"
        value="All"
        count={ownerCount}
        disabled
        tooltip="Filtering coming v7.1"
      />
      <FilterChip
        label="Status"
        value="Active"
        count={activeCount}
        disabled
        tooltip="Filtering coming v7.1"
      />
      <FilterChip
        label="Milestone"
        value="Any"
        disabled
        tooltip="Filtering coming v7.1"
      />
      <FilterChip
        label="Period"
        value={period.label}
        disabled
        tooltip="Custom range coming v7.1"
      />
      <GroupByToggle value={groupBy} onChange={onGroupByChange} />
    </div>
  );
}
